import FormatMixin from '../../Application/mixins/FormatMixin';

export default {
  mixins: [FormatMixin],
  data() {
    return {
      VALUE: 0,
      PERCENT: 1,
    };
  },
  methods: {
    hasActiveDiscountConfiguration(discountData) {
      return discountData.hasPercentage && discountData.percentage > 0;
    },
    getTotalProductsTradePriceInPdv(trade) {
      return trade.productOfTradeCollection.reduce(
        (previousValue, pdvVendaProduto) =>
          previousValue + pdvVendaProduto.price * pdvVendaProduto.quantity,
        0,
      );
    },
    getTotalProductsStockPriceInPdv(trade) {
      return trade.productOfTradeCollection.reduce(
        (previousValue, pdvVendaProduto) =>
          previousValue + pdvVendaProduto.product.stockPrice * pdvVendaProduto.quantity,
        0,
      );
    },
    getFinalPercentageDiscount(totalProductsPrice, discount) {
      if (!discount || !totalProductsPrice) return 0;

      return (discount * 100) / totalProductsPrice;
    },
    getPercentageDiscountOnPdvTrade(trade) {
      let totalPriceDifference = 0;
      const totalProductsStockPrice = this.getTotalProductsStockPriceInPdv(trade);
      const totalProductsTradePrice = this.getTotalProductsTradePriceInPdv(trade);
      const { discount } = trade;

      if (totalProductsTradePrice < totalProductsStockPrice) {
        totalPriceDifference = totalProductsStockPrice - totalProductsTradePrice;
        const totalDiscount = discount + totalPriceDifference;
        return this.getFinalPercentageDiscount(totalProductsStockPrice, totalDiscount);
      }

      return this.getFinalPercentageDiscount(totalProductsTradePrice, discount);
    },
    getPercentageDiscountOnProduct(product) {
      const stockUnitPrice = product.product.stockPrice;
      const unitDiscount = product.discount / product.quantity;

      if (product.price < stockUnitPrice) {
        const priceDifference = stockUnitPrice - product.price;
        return ((unitDiscount + priceDifference) * 100) / stockUnitPrice;
      }

      return (unitDiscount * 100) / product.price;
    },
    calculateTotalItem(item) {
      const price = this.valorUS(item.price);
      const quantity = this.valorUS(item.quantity);
      const discount = this.valorUS(item.discount);

      if (item.discountType === this.PERCENT) {
        return price * quantity - price * quantity * (discount / 100);
      }

      return price * quantity - discount;
    },
  },
};
